import { Phone, Clock, MapPin } from "lucide-react";
import { BRAND, NAV_LINKS } from "@/data/content";
import { scrollToHash } from "@/lib/ui";
import { Mark } from "@/components/Motif";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-gold/15 bg-cocoa-950">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-14 grid gap-12 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <Mark className="w-9 h-9 text-gold" />
            <span className="font-display font-semibold tracking-[0.14em] text-cream">SAMIJ SWEETS</span>
          </div>
          <p className="mt-4 text-sm text-cream/55 leading-relaxed max-w-xs">
            Fresh traditional sweets &amp; morning delights, made in pure desi ghee — every day from 5 AM.
          </p>
        </div>

        <div>
          <p className="text-[10px] uppercase tracking-[0.28em] text-gold/80">Explore</p>
          <ul className="mt-4 space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                <a
                  data-testid={`footer-link-${l.id}`}
                  href={l.hash}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToHash(l.hash);
                  }}
                  className="text-sm text-cream/60 hover:text-gold transition-colors duration-200"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-[10px] uppercase tracking-[0.28em] text-gold/80">Reach Us</p>
          <div className="mt-4 space-y-3 text-sm text-cream/60">
            <a data-testid="footer-call-1" href={`tel:${BRAND.phones[0]}`} className="flex items-center gap-3 hover:text-gold transition-colors duration-200">
              <Phone className="w-4 h-4 text-gold/70" /> {BRAND.phones[0]}
            </a>
            <a data-testid="footer-call-2" href={`tel:${BRAND.phones[1]}`} className="flex items-center gap-3 hover:text-gold transition-colors duration-200">
              <Phone className="w-4 h-4 text-gold/70" /> {BRAND.phones[1]}
            </a>
            <p className="flex items-center gap-3">
              <Clock className="w-4 h-4 text-gold/70" /> {BRAND.hours} · Everyday
            </p>
            <p className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-gold/70 mt-0.5 shrink-0" /> {BRAND.address}
            </p>
          </div>
        </div>
      </div>
      <div className="border-t border-gold/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-cream/40">© {new Date().getFullYear()} Samij Sweets · Banskandi</p>
          <p className="font-bengali text-sm text-gold/60">মিষ্টি মানে ভালোবাসা</p>
        </div>
      </div>
    </footer>
  );
}
